import useTooltip from "../hooks/useTooltip.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function withTooltip(BaseComponent) {
  let containerProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    style: {
      position: 'relative',
      width: 'inherit',
      height: 'inherit'
    }
  };
  let renderContainer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (children, props) => /*#__PURE__*/_jsx("div", {
    ...props,
    children: children
  });
  const WrappedComponent = props => {
    const tooltipProps = useTooltip();
    return renderContainer(/*#__PURE__*/_jsx(BaseComponent, {
      ...tooltipProps,
      ...props
    }), containerProps);
  };
  return WrappedComponent;
}